"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.listVerifications = exports.confirmVerificationForm = exports.changeVerificationStatus = exports.setResponsibleSecurityOfficer = exports.getVerification = exports.findVerificationStatus = exports.sendVerificationDocuments = exports.findVerification = exports.client = void 0;
var axios_1 = __importDefault(require("@vtblife/axios"));
exports.client = axios_1.default.create();
exports.client.defaults.paramsSerializer = encode;
exports.client.defaults.baseURL = "/api/client-verification";
function findVerification(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var params = _b.params, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "get",
                        url: "/v1/verification/kyc",
                        data: {},
                        params: params,
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.findVerification = findVerification;
function sendVerificationDocuments(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var data = _b.data, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "post",
                        url: "/v1/verification/kyc/documents",
                        data: data,
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.sendVerificationDocuments = sendVerificationDocuments;
function findVerificationStatus(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var params = _b.params, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "get",
                        url: "/v1/verification/kyc/status",
                        data: {},
                        params: params,
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.findVerificationStatus = findVerificationStatus;
function getVerification(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var urlParams = _b.urlParams, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "get",
                        url: "/v1/verification/kyc/".concat(urlParams.verificationId),
                        data: {},
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.getVerification = getVerification;
function setResponsibleSecurityOfficer(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var data = _b.data, urlParams = _b.urlParams, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "post",
                        url: "/v1/verification/kyc/".concat(urlParams.verificationId, "/security-officer"),
                        data: data,
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.setResponsibleSecurityOfficer = setResponsibleSecurityOfficer;
function changeVerificationStatus(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var data = _b.data, urlParams = _b.urlParams, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "put",
                        url: "/v1/verification/kyc/".concat(urlParams.verificationId, "/status"),
                        data: data,
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.changeVerificationStatus = changeVerificationStatus;
function confirmVerificationForm(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var data = _b.data, urlParams = _b.urlParams, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "post",
                        url: "/v1/verification/kyc/".concat(urlParams.verificationId, ":confirm"),
                        data: data,
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.confirmVerificationForm = confirmVerificationForm;
function listVerifications(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var data = _b.data, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "post",
                        url: "/v1/verification/kyc:list",
                        data: data,
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.listVerifications = listVerifications;
// @TODO: move to @vtblife/api-publisher after merge
// copied from https://github.com/Gozala/querystring/blob/8c9e090786d72db3172ad2c342096c2b42cedb2d/encode.js
function encode(obj) {
    var sep = "&";
    var eq = "=";
    var name = "";
    if (obj === null) {
        obj = undefined;
    }
    if (typeof obj === "object") {
        return Object.keys(obj)
            .map(function (k) {
            var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
            if (Array.isArray(obj[k])) {
                return obj[k]
                    .map(function (v) {
                    return ks + encodeURIComponent(stringifyPrimitive(v));
                })
                    .join(sep);
            }
            else {
                return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
            }
        })
            .filter(Boolean)
            .join(sep);
    }
    if (!name) {
        return "";
    }
    return (encodeURIComponent(stringifyPrimitive(name)) +
        eq +
        encodeURIComponent(stringifyPrimitive(obj)));
}
function stringifyPrimitive(v) {
    switch (typeof v) {
        case "string":
            return v;
        case "boolean":
            return v ? "true" : "false";
        case "number":
            return isFinite(v) ? v : "";
        default:
            return "";
    }
}
